

import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import Card from '@/components/Card/index.vue';
import Button from '@/components/Button/index.vue';
import Heading from '@/components/Heading/index.vue';
import recoverPasswordService from '@/services/user/recover-password';
import {
  Input, Container, Title, WrapperButton, Message, WrapperInput,
} from './styles';

type VForm = Vue & { reset: () => void; fields: any; errors: any };

export default Vue.extend({
  components: {
    Input,
    Button,
    Card,
    WrapperButton,
    ValidationObserver,
    Container,
    Title,
    Message,
    WrapperInput,
    Heading,
  },
  data() {
    return {
      cardBrand: '',
      loading: false,
      recovered: false,
      error: '',
      cardErrors: {} as any,
      email: '',
      name: '',
      card: {
        cardNumber: '',
        cardExpiry: '',
        cardCvc: '',
      },
      disabled: true,
    };
  },
  computed: {
    form(): VForm {
      return this.$refs.form as VForm;
    },
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      this.error = '';
      const stDns = process.env.VUE_APP_APPLICATION_DNS;

      const response = await recoverPasswordService({
        stEmail: this.email,
        stDns,
      });

      this.loading = false;

      if (response.hasErrors) {
        this.error = response.message;
        return;
      }

      this.recovered = true;
    },
  },
});
